/**
 * Плашка середовища після знака (docs/ux/brand/README.md, розд. 6–7): видиме «ТЕСТ» /
 * «ЛОКАЛЬНО» + візуально прихований опис. Не `aria-label` на `span`: без ролі ARIA 1.2 його
 * забороняє, і читачі екрана часто ігнорують. На prod не рендериться зовсім.
 */
import { type AppEnv, appEnv, envLabel } from './env.ts';

export function EnvBadge({ env = appEnv() }: { env?: AppEnv }) {
  const label = envLabel(env);
  if (!label) return null;
  return (
    <span className="env-pill">
      {label.word}
      <span className="sr-only">{label.hint}</span>
    </span>
  );
}
